import { render, staticRenderFns } from "./task-list-filter.vue?vue&type=template&id=645e85bb&scoped=true"
import script from "./task-list-filter.vue?vue&type=script&lang=js"
export * from "./task-list-filter.vue?vue&type=script&lang=js"
import style0 from "./task-list-filter.vue?vue&type=style&index=0&id=645e85bb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645e85bb",
  null
  
)

export default component.exports